/**
 * Raw primitive color scales — brand chips plus Tailwind-style ramps.
 */

export const palette = {
  Purple: '#7B53D1',
  DarkPurple: '#7D55D3',
  LightPurple: '#F0E9FF',
  Iris: '#384DD6',
  Blue: '#071360',
  LightBlue: '#E3E6F6',
  Red: '#BA2323',
  LightRed: '#FFE0E0',
  Green: '#13A83D',
  LightGreen: '#E5EFE8',
  Magnolia: '#F0F2FF',
  SkyBlue: '#BBC2FF',
  White: '#FFFFFF',
  Black: '#161616',
  Gray: '#595959',
  Silver: '#717171',
  LightGray: '#D7D7D7',
  SpanishGray: '#969696',
  OffWhite: '#F3F3F3',
  CulturedWhite: '#EDEDED',
  NewPurple: '#8B83BA',
  Pink: '#F178B6',
  LightPink: '#FCDDEC',
  CornSilk: '#fff3dc',
  PinkLace: '#FFF0FA',
  Yellow: '#F9DC47',
  Secondary: '#5BBCC9',
  SecondaryDark: '#5ABDCA',
  SecondaryRed: '#D84545',

  gray: {
    50: '#fafafa',
    100: '#f4f4f4',
    200: '#e5e5e5',
    300: '#d4d4d4',
    400: '#a3a3a3',
    500: '#737373',
    600: '#595959',
    700: '#404040',
    800: '#262626',
    900: '#1a1a1a',
    950: '#161616',
  },

  blue: {
    50: '#e8eaf4',
    100: '#c5cae8',
    200: '#9fa8d6',
    300: '#7a86c3',
    400: '#5c6bb0',
    500: '#3d519c',
    600: '#2e4287',
    700: '#1f2f6b',
    800: '#142252',
    900: '#071360',
  },

  red: {
    50: '#fef2f2',
    100: '#ffe0e0',
    200: '#ffc9c9',
    300: '#f5a3a3',
    400: '#e76060',
    500: '#d32f2f',
    600: '#BA2323',
    700: '#9a1e1e',
    800: '#6f1515',
    900: '#450a0a',
  },

  green: {
    50: '#ecfdf5',
    100: '#d1fae5',
    200: '#a7f3d0',
    300: '#6ee7b7',
    400: '#34d399',
    500: '#13A83D',
    600: '#0e8a33',
    700: '#0c6e2a',
    800: '#0a5220',
    900: '#052e12',
  },

  amber: {
    50: '#fffbeb',
    100: '#fef3c7',
    200: '#fde68a',
    300: '#fcd34d',
    400: '#fbbf24',
    500: '#f59e0b',
    600: '#d97706',
    700: '#b45309',
    800: '#92400e',
    900: '#78350f',
  },

  purple: {
    50: '#faf5ff',
    100: '#f3e8ff',
    200: '#e9d5ff',
    300: '#d8b4fe',
    400: '#c084fc',
    500: '#7B53D1',
    600: '#6d46c4',
    700: '#5b3aa8',
    800: '#4a2f8a',
    900: '#3d2670',
  },

  pink: {
    50: '#fdf2f8',
    100: '#fce7f3',
    200: '#fbcfe8',
    300: '#f9a8d4',
    400: '#f472b6',
    500: '#F178B6',
    600: '#db2777',
    700: '#be185d',
    800: '#9d174d',
    900: '#831843',
    950: '#500724',
  },
} as const;
